import { BackendService, BackendModel } from '../../core/backend.service';
import { Parametric } from '../parametric.model';
import { User } from '../../security/user/user.model';
import { Cliente } from '../cliente.model';

export class Operacion extends BackendModel {

    static path = '/operaciones/';

    monto: Float32Array;
    cotizacion: Float32Array;
    monedaOrigen: Parametric;
    monedaDestino: Parametric;
    fechaHoraOperacion: any;
    usuarioOperador: User;
    cliente: Cliente;
    tipoOperacion: Parametric;
    formaOperacion: Parametric;
    precio: Float32Array;
    cantidad: Float32Array;

    constructor(protected backendService: BackendService, model?: Operacion) {
      super(backendService, model);
    }

}



// WEBPACK FOOTER //
// ./src/app/cliente/operaciones/operacion.model.ts